import React from 'react';
import {
    Document,
    Packer,
    Paragraph,
    TextRun,
    Table,
    TableCell,
    TableRow,
    Media,
    AlignmentType,
    HeadingLevel,
    WidthType,
    ImageRun
} from "docx";
import { Buffer } from 'buffer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileWord } from '@fortawesome/free-solid-svg-icons';
import { saveAs } from "file-saver";
import { currencyFormat } from '../../js/Functions';
import { logoTC } from "./ImgLogo";

class MovementsWord extends React.Component {
    exportToWord = async () => {
        const { data } = this.props;
        if (!Array.isArray(data) || data.length === 0) return;
        // TOTAL
        let total = 0;
        // Creamos filas de la tabla
        const tableRows  = [
            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "DATE", bold: true })]
                            })
                        ]
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "DESCRIPTION", bold: true })]
                            })
                        ]
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "MOVEMENT TYPE", bold: true })]
                            })
                        ]
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: "AMOUNT", bold: true })]
                            })
                        ]
                    }),
                ]
            }),
            ...data.map((item) => {
                const amount = parseFloat(item.AMOUNT || 0);
                total += amount;
                return new TableRow({
                    children: [
                        new TableCell({ children: [new Paragraph(item.DATE || "")] }),
                        new TableCell({ children: [new Paragraph(item.DESCRIPTION || "")] }),
                        new TableCell({ children: [new Paragraph(item.MOV_TYPE === 1 ? "ENTRY" : "EXIT")] }),
                        new TableCell({
                            children: [new Paragraph({ text: `$${amount.toFixed(2)}` })],
                        }),
                    ],
                });
            }),
        ];

        // Documento
        const doc = new Document({
            styles: {
                default: {
                    document: {
                        run: {
                            font: "Cabin", // Usar tu fuente preferida
                        },
                    },
                },
            },
            sections: [
                {
                    children: [
                        // LOGO
                        new Paragraph({
                            children: [
                                new ImageRun({
                                    data: Buffer.from(logoTC, "base64"),
                                    transformation: {
                                        width: 180,
                                        height: 100,
                                    },
                                }),
                            ],
                            alignment: AlignmentType.LEFT,
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({ text: "", break: 1 }) // Agrega un salto de línea visual
                            ],
                        }),
                        // TÍTULO
                        new Paragraph({
                            text: "DEPOSITS AND ADDITIONS",
                            heading: HeadingLevel.HEADING_1,
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 200 },
                        }),

                        // TABLA
                        new Table({
                            rows: tableRows,
                            width: {
                                size: 100,
                                type: WidthType.PERCENTAGE,
                            },
                        }),

                        // TOTAL
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `Total Deposits and Additions: $${total.toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })}`,
                                    bold: true,
                                }),
                            ],
                            spacing: { before: 300 },
                        }),
                    ],
                },
            ],
        });

        // Guardar archivo
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "Movement_Items.docx");
        });
    }
    render() {
        const { data } = this.props;
        if (!Array.isArray(data) || data.length === 0) return null;
        return (
            <button
                style={{ color: '#FFFFFF' }}
                type="button"
                className="btn btn-info btn-sm"
                onClick={this.exportToWord}
            >
                <FontAwesomeIcon style={{ color: '#FFFFFF' }} icon={faFileWord} />
            </button>
        );
    }
}

export default MovementsWord;